import React from "react";
import { NumberInput } from "./NumberInput";
import { SelectInput } from "./SelectInput";
import { TextInput } from "./TextInput";
import { DateInput } from "./DateInput";
import { SliderInput } from "./SliderInput";
import { RadioInput } from "./RadioInput";
import { CheckBoxInput } from "./CheckBoxInput";
import {FileInput} from "./FileInput";
import {InputHelperOptionalParameters} from "./InputHelper";
import {ParagraphInput} from "./ParagraphInput";

export enum InputTypes {
  "Date",
  "InlineString",
  "MultilineString",
  "Number",
  "Select",
  "Slider",
  "Radio",
  "CheckBox",
  "Ignore",
  "File"
}

type DynamicInputFormTypeBase = {
  dataType:
    | InputTypes.Date
    | InputTypes.InlineString
    | InputTypes.MultilineString
    | InputTypes.Number
    | InputTypes.CheckBox
    | InputTypes.File;

  accessor: string;
  Header: string;
};

type DynamicInputFormSlider = {
  dataType: InputTypes.Slider;
  min: number;
  max: number;
  accessor: string;
  Header: string;
};

type DynamicInputFormTypeOptions = {
  dataType: InputTypes.Select | InputTypes.Radio;
  accessor: string;
  Header: string;
  options: string[];
};

export type DynamicInputFormType =
  | DynamicInputFormTypeBase
  | DynamicInputFormTypeOptions
  | DynamicInputFormSlider;

export function DynamicInput({ formType, inlineLabels=false}: { formType: DynamicInputFormType, inlineLabels?: boolean }) {
  const defaultHelperParameters: InputHelperOptionalParameters = {label: formType.Header, inlineLabel: inlineLabels}
  
  if (formType.dataType === InputTypes.Number) {
    return <NumberInput name={formType.accessor} helperParameters={defaultHelperParameters}/>;
  }

  if (formType.dataType === InputTypes.InlineString) {
    return <TextInput name={formType.accessor} helperParameters={defaultHelperParameters}/>;
  }

  if (formType.dataType === InputTypes.MultilineString) {
    return <ParagraphInput name={formType.accessor} helperParameters={defaultHelperParameters}/>;
  }

  if (formType.dataType === InputTypes.Date) {
    return <DateInput name={formType.accessor} defaultDate={new Date()} helperParameters={defaultHelperParameters}/>;
  }

  if (formType.dataType === InputTypes.Select) {
    return (
      <SelectInput
        name={formType.accessor}
        options={formType.options}
        helperParameters={defaultHelperParameters}
      />
    );
  }

  if (formType.dataType === InputTypes.Radio) {
    return (
      <RadioInput
        name={formType.accessor}
        options={formType.options}
        helperParameters={defaultHelperParameters}
      />
    );
  }

  if (formType.dataType === InputTypes.Slider) {
    return (
      <SliderInput
        name={formType.accessor}
        min={formType.min}
        max={formType.max}
        helperParameters={defaultHelperParameters}
      />
    );
  }

  if (formType.dataType === InputTypes.CheckBox) {
    return <CheckBoxInput name={formType.accessor} helperParameters={defaultHelperParameters}/>;
  }

  if (formType.dataType === InputTypes.File) {
    return <FileInput name={formType.accessor} helperParameters={defaultHelperParameters}/>;
  }

  if (formType.dataType === InputTypes.Ignore) {
    return <> </>;
  }

  return <> </>;
}
